module.exports = __webpack_public_path__ + "static/media/m_w_hw_35.06b55e5b.png";